import { createContext, useContext, useEffect, useState } from "react";

const SettingsContext = createContext(null);

// Apply persisted settings immediately on module load (before first render)
// so there's no flash of wrong theme/lang
const savedTheme = localStorage.getItem("nf_theme") || "light";
const savedLang = localStorage.getItem("nf_language") || "bn";
if (savedTheme === "dark") document.documentElement.classList.add("dark");
document.documentElement.setAttribute("lang", savedLang);

export const SettingsProvider = ({ children }) => {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("nf_theme") || "light",
  );
  const [language, setLanguage] = useState(
    () => localStorage.getItem("nf_language") || "bn",
  );

  // Apply / remove the "dark" class on <html> whenever theme changes
  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("nf_theme", theme);
  }, [theme]);

  // Sync lang attribute on <html> and persist
  useEffect(() => {
    document.documentElement.setAttribute("lang", language);
    localStorage.setItem("nf_language", language);
  }, [language]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "light" ? "dark" : "light"));

  const changeLanguage = (lang) => setLanguage(lang);

  return (
    <SettingsContext.Provider
      value={{ theme, toggleTheme, language, changeLanguage }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be used inside SettingsProvider");
  return ctx;
};
